import type { CreateReagentLotInput, ReagentItemStock } from '#shared/types';
import { type Named, nameOptions } from '#client/lib/form-choices';

export const EMPTY_LOT_ENTRY: CreateReagentLotInput = {
  item_id: 0,
  lot_no: '',
  expiry_at: '',
  quantity_packs: 1,
  pack_price: 0,
  supplier_id: null,
  note: '',
};

/**
 * The form after a successful entry: same reagent, supplier, price and expiry,
 * fresh lot. Entering three lots of one kit in a row is the common case at a
 * delivery.
 */
export function nextLotEntry(current: CreateReagentLotInput): CreateReagentLotInput {
  return { ...current, lot_no: '', quantity_packs: 1, note: '' };
}

/** The one conversion, shown before it is committed: packs × pack size. */
export function stockAddedBase(
  selected: ReagentItemStock | undefined,
  quantityPacks: number,
): number {
  return selected ? quantityPacks * selected.pack_size_base : 0;
}

/** The bench filter: every department, led by "All". */
export function benchOptions(departments: readonly Named[]) {
  return [{ value: '', label: 'All' }, ...nameOptions(departments)];
}
